
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91category_930AzwW_L7kvkPsgAqac0z1XOetTzw179S4oDDzY3yTpoMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/categories/[category].vue?macro=true";
import { default as _91slug_9309i70RjU8OUusI4SGsrlKWwMtTDV_AJxKLLZg_wlRD4Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/[slug].vue?macro=true";
import { default as _91id_93byVmY_H8LWELjsj8fCKocAcLhCRU3m5LrRsn_wKasP8Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/proposals/pages/proposals/[id].vue?macro=true";
import { default as auth18XV0se9JxrUqC4IqFxTmqvs07VEfyFfRzINNtyD5fwMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/auth.vue?macro=true";
import { default as _91id_93yYfc3SKsZJaBDUGoeVYZVqGvYavXgW8IGqnUUYbWcBMMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/invoices/[id].vue?macro=true";
import { default as _91id_93HgnnAf4O4EkbErF_Znmi9tQZhfsHa0FNCIdxw4C4amsMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/files/folders/[id].vue?macro=true";
import { default as _91slug_93N90UxcPIUKCwHb60e3IE9phiuIFw0eUgcnkBXXJPlGMMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/articles/[slug].vue?macro=true";
import { default as _91slug_93X_h9Oca1nT9_eI99z3c0FgFGqYpWFtf0K4rnmODTAzsMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/collections/[slug].vue?macro=true";
import { default as indextQSf3HyxJOscoxYT_IHtQaCh_7TeoSrIGhyJ6rkqlj8Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/invoices/index.vue?macro=true";
import { default as billingC4mREX4bXSY_lBzfzTpELri7m76q0bataoQFZI_gAcYMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/billing.vue?macro=true";
import { default as conversationsNAGu9d7SyAkYsQdD6nnDt2JoK6_NpyTCO_IU4sKQra0Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/conversations.vue?macro=true";
import { default as filesJlj_EnkgxFag94yq1DEGvfUrojIzIuNscpY_PkZjVhwMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/files.vue?macro=true";
import { default as tasksdJeU1_fnV1QNg_fwUCKVmHaOSScIhHGie0_3B1_qePcMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/tasks.vue?macro=true";
import { default as index5UcBR60ZfTSeyrZUnZY0vqruFUgHi1GQRi8SfLSIl6MMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/index.vue?macro=true";
import { default as _91id_93VppLMMmVsee7cVsm6lietFXgbr6QptERcP5_K3VN5k0Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id].vue?macro=true";
import { default as indexSiz3NsILSsWyjQ3oJtnKCWIlLA6a06PKHA7HaCHl7l0Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/account/index.vue?macro=true";
import { default as indexqdmHeRruz3jDMps7G_zV31vb4Eth3SiF9e0pQJct_80Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/index.vue?macro=true";
import { default as index5r3xSM1K2o0QcaM8iw_bUNKOiIpvjPnlLhARsy0Jf_YMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/files/index.vue?macro=true";
import { default as indexD_puaCYL72hr4b45dZG6w5ZA5SlEEWdn2jcdwJOEp7IMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/index.vue?macro=true";
import { default as indexItkQz1ed8OO1BdeuMvkcoqsqYFnJRsBufBtTlb2DTL8Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/index.vue?macro=true";
import { default as indexTgzLRUVY2AmqV2H_WkBj3E_UK8se4E3TiO6NXGCKZ54Meta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/index.vue?macro=true";
import { default as portalG9yfQv1pDnVfNLMgfKHwnxJjmj6cpugeymhBoORdqEwMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal.vue?macro=true";
import { default as indexz74htG3N_eUSsuOtk1xYxbfbaG2XpMQ1AiUbJ8Ob2hQMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/index.vue?macro=true";
import { default as projectsAl53Bv9Y_o4S7W6YmyoyY3gmlqtcEVX_IXKc2SD7vvcMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/projects.vue?macro=true";
import { default as virtual_45tour2qz1QemIo6IH_on1UUwKzQcZpB_jWGMTsyBRjWGzhNUMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/virtual-tour.vue?macro=true";
import { default as _91_46_46_46permalink_93M9_ngVpsfKkkoXHfYIH_DHrsuUZN9t07oEB06AqXIBUMeta } from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/[...permalink].vue?macro=true";
import { default as component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquMMeta } from "/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7__@babel+plugin-s_e2eb9020c3576dd4fdd816534d9f0319/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquM } from "/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7__@babel+plugin-s_e2eb9020c3576dd4fdd816534d9f0319/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "posts-categories-category",
    path: "/posts/categories/:category()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/categories/[category].vue")
  },
  {
    name: "posts-slug",
    path: "/posts/:slug()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/[slug].vue")
  },
  {
    name: "proposals-id",
    path: "/proposals/:id()",
    meta: _91id_93byVmY_H8LWELjsj8fCKocAcLhCRU3m5LrRsn_wKasP8Meta || {},
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/proposals/pages/proposals/[id].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: auth18XV0se9JxrUqC4IqFxTmqvs07VEfyFfRzINNtyD5fwMeta || {},
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/auth.vue")
  },
  {
    name: portalG9yfQv1pDnVfNLMgfKHwnxJjmj6cpugeymhBoORdqEwMeta?.name,
    path: "/portal",
    meta: { ...(portalG9yfQv1pDnVfNLMgfKHwnxJjmj6cpugeymhBoORdqEwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal.vue"),
    children: [
  {
    name: "portal-billing-invoices-id",
    path: "billing/invoices/:id()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/invoices/[id].vue")
  },
  {
    name: "portal-files-folders-id",
    path: "files/folders/:id()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/files/folders/[id].vue")
  },
  {
    name: "portal-help-articles-slug",
    path: "help/articles/:slug()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/articles/[slug].vue")
  },
  {
    name: "portal-help-collections-slug",
    path: "help/collections/:slug()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/collections/[slug].vue")
  },
  {
    name: "portal-billing-invoices",
    path: "billing/invoices",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/invoices/index.vue")
  },
  {
    name: _91id_93VppLMMmVsee7cVsm6lietFXgbr6QptERcP5_K3VN5k0Meta?.name,
    path: "projects/:id()",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id].vue"),
    children: [
  {
    name: "portal-projects-id-billing",
    path: "billing",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/billing.vue")
  },
  {
    name: "portal-projects-id-conversations",
    path: "conversations",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/conversations.vue")
  },
  {
    name: "portal-projects-id-files",
    path: "files",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/files.vue")
  },
  {
    name: "portal-projects-id-tasks",
    path: "tasks",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/tasks.vue")
  },
  {
    name: "portal-projects-id",
    path: "",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/[id]/index.vue")
  }
]
  },
  {
    name: "portal-account",
    path: "account",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/account/index.vue")
  },
  {
    name: "portal-billing",
    path: "billing",
    redirect: "/portal/billing/invoices",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/billing/index.vue")
  },
  {
    name: "portal-files",
    path: "files",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/files/index.vue")
  },
  {
    name: "portal-help",
    path: "help",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/help/index.vue")
  },
  {
    name: "portal-projects",
    path: "projects",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/projects/index.vue")
  },
  {
    name: "portal",
    path: "",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/layers/portal/pages/portal/index.vue")
  }
]
  },
  {
    name: "posts",
    path: "/posts",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/posts/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/projects.vue")
  },
  {
    name: "virtual-tour",
    path: "/virtual-tour",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/virtual-tour.vue")
  },
  {
    name: "permalink",
    path: "/:permalink(.*)*",
    component: () => import("/private/tmp/bvgci-published-order-production.I0Xvcn/app/pages/[...permalink].vue")
  },
  {
    name: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquMMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquM
  },
  {
    name: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquMMeta?.name,
    path: "/portfolio",
    component: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquM
  },
  {
    name: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquMMeta?.name,
    path: "/about-us",
    component: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquM
  },
  {
    name: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquMMeta?.name,
    path: "/contact",
    component: component_45stub5VL3QFT12_PLwxazFXuDHdicGmrBa6j2S0puKlQiquM
  }
]